import React from 'react';
import './logo.css';

/**
 * Brand logo. Renders an inline SVG mark (leaf + sprout) alongside the
 * Tamil / English wordmark. Self-contained so no image asset is required;
 * drop a real logo.png into src/assets and swap the mark if desired.
 *
 * @param {'light'|'dark'} variant  color scheme (light = for dark backgrounds)
 */
export default function Logo({
  variant = 'dark',
  compact = false,
  showMark = true,
  showTamil = true,
}) {
  return (
    <span className={`logo logo--${variant} ${compact ? 'logo--compact' : ''}`}>
      {showMark && (
        <span className="logo__mark" aria-hidden="true">
          <svg viewBox="0 0 48 48" width="100%" height="100%" role="img">
            <circle cx="24" cy="24" r="23" className="logo__disc" />
            {/* stem */}
            <path
              d="M24 38 C24 30 24 24 24 16"
              className="logo__stem"
              fill="none"
              strokeWidth="2.4"
              strokeLinecap="round"
            />
            {/* left leaf */}
            <path
              d="M24 26 C16 26 12 20 12 13 C20 13 24 18 24 26 Z"
              className="logo__leaf"
            />
            {/* right leaf */}
            <path
              d="M24 22 C32 22 36 16 36 9 C28 9 24 14 24 22 Z"
              className="logo__leaf logo__leaf--alt"
            />
          </svg>
        </span>
      )}
      <span className="logo__text">
        {showTamil && <span className="logo__tamil">மகிழ்</span>}
        <span className="logo__name">
          Mahizh <span>Natural Farming</span>
        </span>
      </span>
    </span>
  );
}
